export default __webpack_public_path__ + "static/media/img-classification.f3b66cb4.gif";